// import React, { useEffect } from "react";
import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import Router from "./router";
// import Api from "./api";

function App() {
  // const getPlans = async () => {
  //   await Api.subscription.plans();
  // };

  // useEffect(() => {
  //   getPlans();
  // });

  return (
    <Provider store={store}>
      <Router />
    </Provider>
  );
}

export default App;
